<template>
  <g>
    <g 
      v-for="spot in centerSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'temperature'"
      />
    </g>

    <!-- NOTE: Image mask for thing -->
    <map-mask-image />

    <!-- NOTE: Contour spot for thing -->
    <g 
      v-for="spot in individualSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'temperature'"
      />
    </g>
  </g>    
</template>

<script>
import map from '@/mixins/map.js';
import mapMaskImage from '@/components/map/map_mask_image.vue';
import visualizationContour from '@/components/map/visualization/partials/contours.vue';
import visualizationContourSpot from '@/components/map/visualization/partials/contours_spot.vue';

export default {
  components: {
    mapMaskImage,
    visualizationContour,
    visualizationContourSpot,
  },
  mixins: [map],
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    temperatureSpots: (vm) => vm.spots.filter((spot) => vm.isPrivateSpot(spot)),
    centerSpots: (vm) => vm.temperatureSpots.filter((spot) => vm.isCenterSpot(spot.tags || [])),
    individualSpots: (vm) => vm.temperatureSpots.filter((spot) => vm.isIndividualSpot(spot.tags || [])),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getTemperatureThings();
      this.getSeasonalTemperatureSetting();
      this.$store.commit('visualization/setLineInterval', { layerType: 'temperature', value: 0.2 });
    },
    async getTemperatureThings() {
      await this.$store.dispatch('visualization/getTemperatureThings');
    },
    async getSeasonalTemperatureSetting() {
      await this.$store.dispatch('visualization/getSeasonalTemperatureSetting');
    },
  },
};
</script>



// WEBPACK FOOTER //
// temperature.vue?670d365c